import { isBefore, isValid } from 'date-fns';
import { DateRange } from '../types';

export interface ActiveDateField {
  range: 'range' | 'comparison';
  field: 'start' | 'end';
}

export const isValidDate = (date: Date | undefined): date is Date => !!date && isValid(date);

export const getNextState = (
  prevActive: ActiveDateField,
  prevRange: DateRange,
  _nextPreset: string,
  date: Date
): [ActiveDateField, DateRange] => {
  const from = isValidDate(prevRange.from) ? prevRange.from : undefined;
  const to = isValidDate(prevRange.to) ? prevRange.to : undefined;
  const hasRange = !!from && !!to;

  if (!hasRange) {
    if (prevActive.field === 'start' || !from) {
      return [
        { field: 'end', range: prevActive.range },
        { ...prevRange, from: date, to: undefined },
      ];
    }
    if (isBefore(date, from)) {
      return [
        { field: 'start', range: prevActive.range },
        { ...prevRange, from: date, to: from },
      ];
    }
    return [
      { field: 'start', range: prevActive.range },
      { ...prevRange, from, to: date },
    ];
  }

  return [
    { field: 'end', range: prevActive.range },
    { ...prevRange, from: date, to: undefined },
  ];
};
